/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TermsSource } from './TermsSource';
import {
    TermsSourceFromJSON,
    TermsSourceFromJSONTyped,
    TermsSourceToJSON,
} from './TermsSource';

/**
 * 
 * @export
 * @interface CreateOfferRequestSource
 */
export interface CreateOfferRequestSource {
}

/**
 * Check if a given object implements the CreateOfferRequestSource interface.
 */
export function instanceOfCreateOfferRequestSource(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateOfferRequestSourceFromJSON(json: any): CreateOfferRequestSource {
    return CreateOfferRequestSourceFromJSONTyped(json, false);
}

export function CreateOfferRequestSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOfferRequestSource {
    return json;
}

export function CreateOfferRequestSourceToJSON(value?: CreateOfferRequestSource | null): any {
    return value;
}

